import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('home');
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavClick = (sectionId) => {
        if (location.pathname === '/') {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
        setIsMenuOpen(false);
        setActiveSection(sectionId);
    };

    useEffect(() => {
        const handleScroll = () => {
            const sections = ['home', 'features', 'about', 'cta', 'contact'];
            const scrollPosition = window.scrollY + 100;

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className="navbar">
            <div className="container">
                <div className="nav-content">
                    <Link
                        to="/"
                        className="nav-logo"
                    >
                        <span className="logo-text">TerraCodeCli</span>
                        <span className="logo-subtitle">by TerraAGI</span>
                    </Link>

                    <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                        <Link
                            to="/"
                            className={`nav-link ${location.pathname === '/' && activeSection === 'home' ? 'active' : ''}`}
                            onClick={() => {
                                if (location.pathname === '/') {
                                    handleNavClick('home');
                                } else {
                                    setIsMenuOpen(false);
                                }
                            }}
                        >
                            Home
                        </Link>
                        <Link
                            to="/"
                            className={`nav-link ${location.pathname === '/' && activeSection === 'features' ? 'active' : ''}`}
                            onClick={() => {
                                if (location.pathname === '/') {
                                    handleNavClick('features');
                                } else {
                                    setIsMenuOpen(false);
                                }
                            }}
                        >
                            Features
                        </Link>
                        <Link
                            to="/"
                            className={`nav-link ${location.pathname === '/' && activeSection === 'about' ? 'active' : ''}`}
                            onClick={() => {
                                if (location.pathname === '/') {
                                    handleNavClick('about');
                                } else {
                                    setIsMenuOpen(false);
                                }
                            }}
                        >
                            About
                        </Link>
                        <Link
                            to="/"
                            className={`nav-link ${location.pathname === '/' && activeSection === 'contact' ? 'active' : ''}`}
                            onClick={() => {
                                if (location.pathname === '/') {
                                    handleNavClick('contact');
                                } else {
                                    setIsMenuOpen(false);
                                }
                            }}
                        >
                            Contact
                        </Link>
                        <Link
                            to="/install"
                            className={`nav-link ${location.pathname === '/install' ? 'active' : ''}`}
                        >
                            Installation
                        </Link>
                        <a
                            href="https://github.com/TerraAGI/terra-code-cli"
                            className="nav-link external"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            GitHub
                        </a>
                    </div>

                    <div className="nav-toggle" onClick={toggleMenu}>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;